module.exports = __webpack_public_path__ + "images/application/i-2fa-b029595e.svg";